export const FETCH_BLOG_LIST_REQUEST = 'blog/FETCH_LIST_REQUEST';
export const FETCH_BLOG_LIST_SUCCESS = 'blog/FETCH_LIST_SUCCESS';
export const FETCH_BLOG_LIST_FAILURE = 'blog/FETCH_LIST_FAILURE';

export const FETCH_BLOG_ITEM_REQUEST = 'blog/FETCH_ITEM_REQUEST';
export const FETCH_BLOG_ITEM_SUCCESS = 'blog/FETCH_ITEM_SUCCESS';
export const FETCH_BLOG_ITEM_FAILURE = 'blog/FETCH_ITEM_FAILURE';

export const CLEAR_BLOG_ITEM = 'blog/CLEAR_ITEM';

